import { RouterProvider } from '@tanstack/react-router';
import { useEffect } from 'react';
import { router } from '@/routes';

declare global {
  var __onautoRouteInventory:
    | {
        routes: Array<{
          pattern: string;
          path: string;
          title: string;
          page: string;
          standalone: boolean;
          isPublic: boolean;
          entersFrom?: string;
        }>;
        entry: { default: string; byRole: Record<string, string> };
      }
    | undefined;
}

export function App() {
  useEffect(() => {
    document.getElementById('root')?.setAttribute('data-app-ready', '1');
    const routes = Object.values(router.routesById)
      .filter((route) => route.id !== '__root__')
      .map((route) => {
        const data = route.options.staticData as {
          title: string;
          page: string;
          standalone: boolean;
          isPublic: boolean;
          entersFrom?: string;
        };
        const path = route.fullPath;
        return {
          pattern: path.replace(/\$([^/]+)/g, '[$1]'),
          path,
          title: data.title,
          page: data.page,
          standalone: data.standalone,
          isPublic: data.isPublic,
          ...(data.entersFrom ? { entersFrom: data.entersFrom } : {}),
        };
      });
    globalThis.__onautoRouteInventory = { routes, entry: { default: '/', byRole: {} } };
  }, []);

  return <RouterProvider router={router} />;
}
